import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Brian L.',
  pet: 'Polo the Pomsky',
  quote: "I've tried so many habit trackers, but having my real dog Polo cheer me on makes all the difference. I haven't missed a day of journaling in a month!",
  avatar: '👨🏻',
  petImage: 'https://cdn.magicpatterns.com/uploads/xwayJoBStWpMdEiyffnsue/idle.png'
}, {
  name: 'James T.',
  pet: 'Max the Golden',
  quote: "The breathing exercises are incredible. Seeing digital Max breathe along with me instantly calms my anxiety. It's the sweetest app on my phone.",
  avatar: '👨🏽',
  petImage: 'https://cdn.magicpatterns.com/uploads/ehze6eRdooopAgjJvUg4C5/idle.png'
}, {
  name: 'Sarah M.',
  pet: 'Luigi the Beagle',
  quote: 'Pawchi turned self-care from a chore into a joy. Checking off my water intake to give Luigi a digital treat is surprisingly motivating!',
  avatar: '👱🏼‍♀️',
  petImage: 'https://cdn.magicpatterns.com/uploads/bKuXUL7RUXEoK5eQMe8PC7/idle.png'
}];
export function Testimonials() {
  return <section id="testimonials" className="py-24 bg-white" data-id="element-144">
      <div className="max-w-7xl mx-auto px-6" data-id="element-145">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-146">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-black text-warmBrown mb-6" data-id="element-147">
            Loved by humans.
            <br data-id="element-148" />
            <span className="text-coral" data-id="element-149">Approved by pets.</span>
          </motion.h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-150">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.5
        }} className="bg-cream rounded-3xl p-8 shadow-sm relative flex flex-col h-full" data-id="element-151">
              <div className="flex gap-1 mb-6" data-id="element-152">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} size={18} className="text-peach" fill="currentColor" data-id="element-153" />)}
              </div>

              <p className="text-warmBrown/80 text-lg mb-8 leading-relaxed italic" data-id="element-154">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center gap-4 mt-auto" data-id="element-155">
                <div className="relative" data-id="element-156">
                  <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center text-2xl shadow-sm" data-id="element-157">
                    {testimonial.avatar}
                  </div>
                  <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-coral rounded-full flex items-center justify-center text-xs border-2 border-cream overflow-hidden" data-id="element-158">
                    {testimonial.petImage ? <img src={testimonial.petImage} alt={testimonial.pet} className="w-full h-full object-cover bg-white" data-id="element-159" /> : testimonial.petEmoji}
                  </div>
                </div>
                <div data-id="element-160">
                  <h4 className="font-bold text-warmBrown" data-id="element-161">
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-warmBrown/60" data-id="element-162">
                    with {testimonial.pet}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}